import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/college/empty.png';
const _withScopeId = n => (_pushScopeId("data-v-496366f5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "flex align-center justify-center"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "暂无数据"
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "new-article-right"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "text-grey"
};
const _hoisted_8 = {
  class: "text-grey flex"
};
const _hoisted_9 = {
  class: "flex",
  style: {
    "margin-left": "16px"
  }
};
const _hoisted_10 = {
  style: {
    "margin-left": "4px"
  }
};
const _hoisted_11 = {
  key: 0,
  class: "bottom"
};
import ModuleCard from "@/views/college/components/ModuleCard.vue";
import { useRoute, useRouter } from "vue-router";
import { College } from "@/api/college";
import { onMounted, reactive, ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'NewestArticle',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const params = reactive({
      pageNo: 1,
      pageSize: 10,
      topicId: route.params.topicId,
      tagIds: route.params.tagId
    });
    const loading = ref(false);
    const list = ref([]);
    const total = ref(0);
    //首页资讯列表
    const getList = async () => {
      loading.value = true;
      const res = await College.NewestInfo(params);
      list.value = res.data.list;
      total.value = res.data.total;
      loading.value = false;
    };
    //专题、标签进入
    const getList2 = async () => {
      loading.value = true;
      const res = await College.NewestInfoEntry(params);
      list.value = res.data;
      total.value = res.count;
      loading.value = false;
    };
    onMounted(() => {
      if (route.name === 'zixun') {
        getList();
      } else {
        getList2();
      }
    });
    //切换页码
    const currentChange = page => {
      params.pageNo = page;
      getList();
    };
    const goBack = () => {
      router.push({
        name: 'zixun'
      });
    };
    //跳转详情
    const toDetail = id => {
      router.push({
        name: 'zixunDetail',
        params: {
          id
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_View = _resolveComponent("View");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(ModuleCard, {
        title: _unref(route).name === 'zixun' ? '最新资讯' : ''
      }, {
        title: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("span", {
          class: "theme-hover",
          onClick: goBack
        }, "获客学院"), _createElementVNode("span", null, "> " + _toDisplayString(_unref(route).query.name), 1)])]),
        default: _withCtx(() => [!list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3)) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item,
            class: "new-article-content",
            onClick: $event => toDetail(item.id)
          }, [_createVNode(_component_el_image, {
            class: "new-article-img",
            src: item.coverId,
            fit: "cover"
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(item.subTitle), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(item.publishTime), 1), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_View)]),
            _: 1
          }), _createElementVNode("span", _hoisted_10, _toDisplayString(item.realViewNum + item.fictitiousViewNum), 1)])])])], 8, _hoisted_4);
        }), 128))]),
        _: 1
      }, 8, ["title"]), _unref(route).name === 'zixun' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_pagination, {
        small: "",
        background: "",
        layout: "prev, pager, next",
        total: total.value,
        class: "mt-4",
        onCurrentChange: currentChange
      }, null, 8, ["total"])])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]]);
    };
  }
});